const RF_CONTROL_WARNING_MESSAGE =
  'Any changes to these parameters may affect the operational performance of a commercial device.  Please confirm that you want to apply these changes.';

const directionMetrics = [
  {
    id: 'beamAzimuth',
    label: 'Azimuth – Electrical',
    hoverMessage: 'Twin reported azimuth direction of the selected HBF beam'
  },
  {
    id: 'beamElevation',
    label: 'Downtilt – Electrical',
    hoverMessage: 'Twin reported downtilt direction of the selected HBF beam (downtilt = -elevation)'
  }
];

const TABLE_TYPES = {
  GAIN: 'gain-table',
  DIRECTION: 'direction-table'
};

const gainMetrics = [
  {
    id: 'HDL_Gain',
    label: 'Downlink gain - Horizontal'
  },
  {
    id: 'VDL_Gain',
    label: 'Downlink gain - Vertical'
  },
  {
    id: 'HUL_Gain',
    label: 'Uplink gain - Horizontal'
  },
  {
    id: 'VUL_Gain',
    label: 'Uplink gain - Vertical'
  }
];

const generateDirectionDataRows = (device) => {
  const dataRows = [];
  let targetRowData = {};

  directionMetrics.forEach((pMetric) => {
    switch (pMetric.id) {
      case 'beamAzimuth':
        targetRowData = {
          parameter: pMetric.value,
          min: device?.rasterInfo?.min_az ?? '',
          max: device?.rasterInfo?.max_az ?? '',
          currentValue: device?.properties?.reported?.antenna_direction?.beamAzimuth ?? '',
          lastUpdated: device?.properties?.reported?.$metadata?.antenna_direction?.beamAzimuth?.$lastUpdated
        };
        break;
      case 'beamElevation':
        targetRowData = {
          parameter: pMetric.value,
          min: device?.rasterInfo?.min_el ?? '',
          max: device?.rasterInfo?.max_el ?? '',
          currentValue: device?.properties?.reported?.antenna_direction?.beamElevation * -1 ?? '',
          lastUpdated: device?.properties?.reported?.$metadata?.antenna_direction?.beamElevation?.$lastUpdated
        };
        break;
      default:
        break;
    }
    dataRows.push({
      hoverMessage: pMetric.hoverMessage,
      parameter: pMetric.label,
      min: targetRowData.min,
      max: targetRowData.max,
      currentValue: targetRowData.currentValue,
      lastUpdated: targetRowData.lastUpdated
    });
  });

  return dataRows;
};

const generateGainDataRows = (device) => {
  const dataRows = [];
  let targetRowData = {};

  gainMetrics.forEach((gMetric) => {
    switch (gMetric.id) {
      case 'HDL_Gain':
        targetRowData = {
          id: gMetric.id,
          parameter: gMetric.value,
          min: device?.properties?.reported?.HDL_Gain?.min ?? '',
          max: device?.properties?.reported?.HDL_Gain?.max ?? '',
          currentValue: device?.properties?.reported?.HDL_Gain?.value ?? '',
          lastUpdated: device?.properties?.reported?.$metadata?.HDL_Gain?.$lastUpdated
        };
        break;
      case 'HUL_Gain':
        targetRowData = {
          id: gMetric.id,
          parameter: gMetric.value,
          min: device?.properties?.reported?.HUL_Gain?.min ?? '',
          max: device?.properties?.reported?.HUL_Gain?.max ?? '',
          currentValue: device?.properties?.reported?.HUL_Gain?.value ?? '',
          lastUpdated: device?.properties?.reported?.$metadata?.HUL_Gain?.$lastUpdated
        };
        break;
      case 'VDL_Gain':
        targetRowData = {
          id: gMetric.id,
          parameter: gMetric.value,
          min: device?.properties?.reported?.VDL_Gain?.min ?? '',
          max: device?.properties?.reported?.VDL_Gain?.max ?? '',
          currentValue: device?.properties?.reported?.VDL_Gain?.value ?? '',
          lastUpdated: device?.properties?.reported?.$metadata?.VDL_Gain?.$lastUpdated
        };
        break;
      case 'VUL_Gain':
        targetRowData = {
          id: gMetric.id,
          parameter: gMetric.value,
          min: device?.properties?.reported?.VUL_Gain?.min ?? '',
          max: device?.properties?.reported?.VUL_Gain?.max ?? '',
          currentValue: device?.properties?.reported?.VUL_Gain?.value ?? '',
          lastUpdated: device?.properties?.reported?.$metadata?.VUL_Gain?.$lastUpdated
        };
        break;
      default:
        break;
    }
    dataRows.push({
      parameter: gMetric.label,
      min: targetRowData.min,
      max: targetRowData.max,
      currentValue: targetRowData.currentValue,
      lastUpdated: targetRowData.lastUpdated
    });
  });
  return dataRows;
};

export {
  directionMetrics,
  gainMetrics,
  TABLE_TYPES,
  RF_CONTROL_WARNING_MESSAGE,
  generateDirectionDataRows,
  generateGainDataRows
};
